import React from 'react';
import './NaatiLogo.css';

/** Public URL for the site logo (served from frontend/public/logo.png). */
export const NAATI_LOGO_SRC = '/logo.png';

export type NaatiLogoSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'hero';

const SIZE_MAP: Record<NaatiLogoSize, number> = {
  xs: 28,
  sm: 36,
  md: 44,
  lg: 56,
  xl: 72,
  hero: 96,
};

export interface NaatiLogoProps {
  size?: NaatiLogoSize | number;
  className?: string;
  imgClassName?: string;
  alt?: string;
  /** When true, size is controlled via CSS classes (no inline dimensions). */
  responsive?: boolean;
}

const NaatiLogo: React.FC<NaatiLogoProps> = ({
  size = 'md',
  className = '',
  imgClassName = '',
  alt = 'NAATI',
  responsive = false,
}) => {
  const explicitSize =
    responsive ? null : typeof size === 'number' ? size : SIZE_MAP[size];

  return (
    <div className={`naati-logo ${className}`.trim()}>
      <img
        src={NAATI_LOGO_SRC}
        alt={alt}
        className={`naati-logo-img ${imgClassName}`.trim()}
        height={explicitSize ?? undefined}
        style={explicitSize != null ? { height: explicitSize, width: 'auto' } : undefined}
      />
    </div>
  );
};

export default NaatiLogo;
